import React, {PureComponent} from 'react';
import * as ReactGA from '../../GA';
import i18n from '../../locales/i18n';
import video from './worn-by-the-best.mp4';
import videoPoster from './worn-by-the-best-poster.jpg';

import './WornByTheBest.css';
import Video from '../../atoms/Video';

export default class WornByTheBest extends PureComponent {
    componentDidMount() {
        ReactGA.pageview(`${i18n.language}/Prizm/TheScienceBehindPrizm`);
    }

    render() {
        return (
            <article className="WornByTheBest">
                <Video
                    className="WornByTheBest-video"
                    src={video}
                    poster="data:image/gif,AAAA"
                    style={{backgroundImage: `url(${videoPoster})`}}
                    autoPlay
                    playsInline
                    muted
                    loop
                    controls
                />
            </article>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/prizm/WornByTheBest.js